import React, { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { motion } from "framer-motion";

const alumniData = [
    {
      "name": "P James Swu",
      "designation": "Additional Deputy Commissioner (ADC) Medziphema",
	  "image": "/assets/images/alumni/P james Swu.jpg",
      "message": `Batch of 1998, Cleared NPSC, Nagaland Civil Services (NCS) exam in 2009 to the post of Extra Assistant Commissioner (EAC).
Currently posted as Additional Deputy Commissioner (ADC) Medziphema.`
	},
  ]
  ;
const Alumni = () => {
	const [emblaRef, emblaApi] = useEmblaCarousel({
		loop: true,
		align: "center",
		containScroll: "trim",
	});

	const scrollNext = useCallback(() => {
		if (emblaApi) emblaApi.scrollNext();
	}, [emblaApi]);

	useEffect(() => {
		if (!emblaApi) return;
		const interval = setInterval(scrollNext, 4000);
		return () => clearInterval(interval);
	}, [emblaApi, scrollNext]);

	return (
		<div className="relative lg:w-1/2 overflow-hidden py-10 mx-auto">
			<h2
				className="text-center text-2xl font-bold text-theme mb-6"
				style={{ textShadow: "1px 1px 1px rgba(0, 0, 0, 0.5)" }}
			>
				Our Alumni
			</h2>
			<div className="embla" ref={emblaRef}>
				<div className="flex w-full">
					{alumniData.map((alum, index) => (
						<motion.div
							key={index}
							className="flex-shrink-0 w-full max-w-lg p-6 mx-auto"
							initial={{ opacity: 0, x: 50 }}
							animate={{ opacity: 1, x: 0 }}
							transition={{ duration: 0.5 }}
						>
							<div className="bg-white rounded-xl shadow-2xl p-8 flex flex-col shadown-2xl">
								<div className="flex flex-col md:flex-row items-center">
									<img
										src={alum.image || "https://www.strasys.uk/wp-content/uploads/2022/02/Depositphotos_484354208_S.jpg"}
										alt={alum.name}
										className="w-64 h-64 aspect-square md:w-48 md:h-48 rounded-full object-cover border-4 border-theme"
									/>
									<div className="mt-4 md:mt-0 md:ml-6 text-center md:text-left">
										<h3 className="text-xl md:text-2xl font-bold text-blue-theme">
											{alum.name}
										</h3>
										<p className="text-md md:text-lg text-gray-600">
											{alum.designation}
										</p>
									</div>
								</div>
									{alum.message && (
										<p className="mt-3 text-gray-500 text-sm md:text-base text-justify">
											{alum.message}
										</p>
									)}
							</div>
						</motion.div>
					))}
				</div>
			</div>
		</div>
	);
};

export default Alumni;
